////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const initKioskCreationAddPrices = {
	[ActionsTypes.POST_KIOSK_ADD_PRICES]: (state) =>
		update(state, {
			columns: {
				isEditingTrigger: {
					$set: false,
				},
				isSearchfieldUpdated: {
					$set: false,
				},
			},
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				addPrices: {
					data: {
						$set: {},
					},
				},
			},
		}),
	[ActionsTypes.POST_KIOSK_ADD_PRICES_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				addPrices: {
					data: {
						$set: payload.data,
					},
				},
				statusId: {
					$set: payload.data.headerParam.progressInfo.statusId,
				},
				requestId: {
					$set: payload.id,
				},
			},
		})
	},
	[ActionsTypes.POST_KIOSK_ADD_PRICES_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.PUT_UPDATE_PRICES]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.PUT_UPDATE_PRICES_SUCCESS]: (state, payload) => {
		const stateCp = cloneDeep(state.initKioskCreation.addPrices.data.headerContent.contentPagined.content)
		const payloadCp = cloneDeep(payload.data.updated)
		const out = stateCp.map((elem) => payloadCp.find((e) => e.id === elem.id) || elem)

		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				addPrices: {
					data: {
						headerContent: {
							contentPagined: {
								content: {
									$set: out,
								},
							},
						},
					},
				},
			},
		})
	},
	[ActionsTypes.PUT_UPDATE_PRICES_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.PUT_VALIDATE_PRICES]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.PUT_VALIDATE_PRICES_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				/*addPrices:{
					data:{
						$set:payload.data
					},
				},*/
				statusId: {
					$set: payload.data.statusId,
				},
			},
		})
	},
	[ActionsTypes.PUT_VALIDATE_PRICES_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_DATA_ADD_PRICES]: (state, _payload) =>
		update(state, {
			initKioskCreation: {
				statusId: {
					$set: 0,
				},
				requestId: {
					$set: null,
				},
				bankDetails: {
					availableOptions: {
						$set: {},
					},
					data: {
						$set: {},
					},
					isEditable: {
						$set: true,
					},
				},
			},
		}),
}

export default initKioskCreationAddPrices
